import React from 'react';
import { Brain, Heart, Users, Shield, Check } from 'lucide-react';

const WellnessPage = () => {
  const wellnessAreas = [
    {
      icon: <Brain className="text-blue-500" size={40} />,
      title: 'Mind & Body',
      description: 'Mental clarity and physical health tips for optimal decision making',
      tips: [
        'Practice mindfulness before placing bets',
        'Take regular breaks from screens',
        'Maintain a consistent sleep schedule',
        'Exercise regularly to reduce stress'
      ]
    },
    {
      icon: <Heart className="text-red-500" size={40} />,
      title: 'Lifestyle & Diet',
      description: 'Nutrition guidance and lifestyle habits for sustained success',
      tips: [
        'Stay hydrated throughout betting sessions',
        'Avoid alcohol when making betting decisions',
        'Eat balanced meals for stable energy',
        'Create a dedicated betting workspace'
      ]
    },
    {
      icon: <Users className="text-green-500" size={40} />,
      title: 'Family & Friends',
      description: 'Building a support network and maintaining healthy relationships',
      tips: [
        'Set clear boundaries with betting time',
        'Be transparent about your betting activities',
        'Involve family in financial planning',
        'Join supportive betting communities'
      ]
    },
    {
      icon: <Shield className="text-purple-500" size={40} />,
      title: 'Responsible Gaming',
      description: 'Tools and resources for maintaining control and betting responsibly',
      tips: [
        'Set strict bankroll limits',
        'Use unit-based betting (1-2% per unit)',
        'Never chase losses',
        'Take regular betting breaks',
        'Seek help if betting becomes problematic'
      ]
    }
  ];

  return (
    <div className="min-h-screen py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Wellness & Balance</h1>
          <p className="text-xl text-gray-600">
            Success in betting requires a balanced lifestyle. We support your journey beyond the numbers.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {wellnessAreas.map((area, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex items-center mb-4">
                {area.icon}
                <h3 className="text-2xl font-semibold ml-4">{area.title}</h3>
              </div>
              <p className="text-gray-600 mb-6">{area.description}</p>
              <ul className="space-y-2">
                {area.tips.map((tip, idx) => (
                  <li key={idx} className="flex items-start">
                    <Check className="text-green-500 mr-2 mt-1" size={16} />
                    <span className="text-gray-700">{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-gradient-to-r from-green-100 to-blue-100 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold mb-4">Need Support?</h2>
          <p className="text-gray-700 mb-6">
            If you're struggling with gambling addiction, help is available.
          </p>
          <div className="flex justify-center gap-4">
            <a
              href="https://www.gamblinghelponline.org.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white px-6 py-3 rounded-full font-medium hover:shadow-lg transition"
            >
              Gambling Help Online
            </a>
            <a
              href="tel:1800858858"
              className="bg-green-500 text-white px-6 py-3 rounded-full font-medium hover:bg-green-600 transition"
            >
              Call 1800 858 858
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WellnessPage;
